import { h } from 'preact'
import { randomizeArray } from '../lib/utils'

import prerender from '../components/prerender'
import Hero from '../components/heroes/copy_page'
import SearchResult from '../components/search_result'

const Collection = ({ data }) => {
  let results = []
  let title = ''

  if (data) {
    results = data.results.map(result => (<SearchResult key={result.unitTypeId} {...result} />))
    title = data.meta['og:title'].content
  }

  const randomizedResults = randomizeArray(results)

  return (
    <div>
      <Hero title={title} />
      <section class='mt-5 mb-5'>
        <div class='container'>
          <div class='row'>
            {randomizedResults}
          </div>
        </div>
      </section>
    </div>
  )
}

export default prerender(Collection)
